// extracted by mini-css-extract-plugin
export default {"wrapper":"A_ObWT"};